<template>
  <div class="popover_wrapper" :class="[classes, { show: parent, mobile: $device?.mobile }]">
    <div class="popover_container" :class="{ show: open, mobile: $device?.mobile }">
      <div class="popover_header">
        <div class="header_content">
          <div v-if="is_title" class="title" v-html="title"></div>
          <slot name="header"> </slot>
        </div>
        <div v-if="is_close" @click.prevent="onClose" class="header_close_btn">
          <i class="fa fa-close"></i>
        </div>
      </div>
      <div v-if="$slots.body" class="popover_body" :class="{ footer: $slots?.footer }">
        <slot name="body"></slot>
        <div v-if="is_loading" class="loading">
          <div class="spinner"></div>
        </div>
      </div>
      <div v-if="$slots?.footer" class="popover_footer">
        <hr class="my-0" />
        <slot name="footer"> </slot>
      </div>
    </div>
  </div>
  <div @click.prevent="handleClose" class="popover_overlay" v-show="parent"></div>
</template>

<script>
export default {
  name: "PopOverModel",
  data() {
    return {
      parent: false
    };
  },
  props: {
    is_title: { type: Boolean, default: true },
    is_loading: { type: Boolean, default: false },
    title: { type: String, default: "Default" },
    open: { type: Boolean, default: false },
    class: { type: [String, Object, Array] },
    onClose: { type: Function }
  },
  watch: {
    open(value) {
      if (value) {
        this.parent = true;
      } else {
        setTimeout(() => {
          this.parent = false;
        }, 500);
      }
    }
  },
  computed: {
    is_close() {
      return "onOnClose" in (this?.$options?.propsData || {});
    },
    classes() {
      return this?.class || "";
    }
  },
  created() {
    /*   console.log(this); */
  },
  methods: {
    handleClose() {
      if (this.is_close) {
        this.$emit("on-close");
      }
    }
  }
};
</script>

<style  lang="scss">
.popover_overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin-top: var(--header_height);
  height: 100%;
  backdrop-filter: blur(1px);
  background-color: var(--dp-c-popover-overlay-background);
  z-index: 1;
}

.popover_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  margin-top: var(--header_height);
  height: 100%;
  z-index: 500;
  visibility: hidden;
  .btn {
    width: 85px !important;
    font-size: var(--fnt-12);
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
  .popover_container {
    /* box-shadow: var(--dp-c-card-shadow); */
    border-left: 2px solid var(--dp-c-border-color);
    background-color: var(--body-background-color);
    height: calc(100% - 40px);
    transform: translateX(100%);
    transition: transform 0.6s ease-in-out;
    &.mobile {
      border-left: 0px;
      transition: transform 0.4s ease-in-out;
    }
    &.show {
      transform: translateX(0);
    }
    .popover_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 0px 15px 0px 10px;
      height: 40px;
      border-bottom: 1px solid var(--dp-c-border-color);
      .title {
        font-weight: 600;
        font-size: var(--fnt-16);
      }
      .header_close_btn {
        width: fit-content;
        color: var(--red-froly);
        font-size: var(--fnt-14);
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .popover_body {
      overflow: auto;
      min-height: calc(100% - 40px);
      max-height: calc(100% - 40px);
      padding: 10px 10px 15px 10px;
      &.footer {
        min-height: calc(100% - 80px) !important;
        max-height: calc(100% - 80px) !important;
      }
    }
    .popover_footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      background-color: var(--body-background-color);
    }
  }
  &.show {
    visibility: visible;
  }
  &.mobile {
    width: 100% !important;
  }
}
/* 
.popover-wrapper.open {
  visibility: visible;
  opacity: 1;
}

.popover-container {
  position: fixed;
  width: 0;
  background-color: var(--body-background-color);
  height: calc(var(--vh) - var(--header_height));
  overflow: hidden;
  padding: 1rem;
  overflow-y: auto;
  z-index: 1;
  right: 0;
  top: var(--header_height);
  transition: 0.3s linear all;
  transform-origin: right top;
}

.popover-wrapper.open .popover-container {
  width: 50%;
}

.popover-overlay {
  position: fixed;
  background-color: var(--body-background-color);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.4;
}

.popover-container .header_wrapper {
  border-bottom: 1px solid var(--body-background-color);
  padding-bottom: 0.2rem;
  margin-bottom: 0.5rem;
}

.popover-container .header_wrapper .close_wrapper i {
  cursor: pointer;
} */
</style>
